import React from "react";
import { useTranslation } from "react-i18next";
import { Spin } from "antd";
import { ContactCard } from "@/common/ContactCard";
import { useRuntimeImage } from "@/entities/runtime-image";
import { NoContactsPage } from "@/pages/ContactsPage/Components/NoContactsPage";
import { handleFullName } from "@/shared/utils/handle-contacts-null";
import styles from "./styles.module.scss";
import { useContactsBar } from "./lib";

export const ContactsBar: React.FC = () => {
  const { t } = useTranslation();
  const { getRuntimeImageURL } = useRuntimeImage();
  const { containerRef, contactCardClickHandler, contactsData, contactsIsLoading } =
    useContactsBar();

  if (contactsIsLoading)
    return (
      <div className={styles["loader"]}>
        <Spin />
      </div>
    );

  if (!contactsData?.length) {
    return (
      <div className={styles["no-contacts"]}>
        <NoContactsPage message={t("contactsPage.noContacts")} />
      </div>
    );
  }

  return (
    <div ref={containerRef} className={styles.container}>
      {contactsData?.map((contact) => {
        return (
          <div
            onClick={() => contactCardClickHandler(contact)}
            className={styles.card}
            key={contact.id}
          >
            <ContactCard
              contact={{
                email: contact?.emails[0]?.email ?? "",
                id: contact.id,
                image: getRuntimeImageURL({ fileId: contact.avatarFile?.fileId ?? "" }),
                name: handleFullName(contact?.firstName, contact?.lastName, contact?.middleName),
                phone: contact?.phones[0]?.number ?? "",
                title: contact?.title ?? "",
              }}
              className={styles["dashboard-contact-card"]}
            />
          </div>
        );
      })}
    </div>
  );
};
